module.exports = __webpack_public_path__ + "static/media/iQuoto-Global-Logo-White.e303d9bd.svg";